import React, { useState } from 'react';
import { Nav, Collapse, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const getUserAndRole = () => {
    let roleId = sessionStorage.getItem('roleId') ? parseInt(sessionStorage.getItem('roleId')) : 0;
    console.log("Role ID en Sidebar:", roleId); // Agrega este log para verificar el roleId
    let userName = sessionStorage.getItem('userName') || 'Usuario';
    return { roleId, userName };
};

function Sidebar({ isOpen, onClose }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { roleId, userName } = getUserAndRole();

    // Estados para controlar qué secciones están expandidas
    const [openSections, setOpenSections] = useState({
        objetos: true,
        supplies: false,
        reportes: false,
        usuarios: false,
        configuraciones: false,
        'excel-import': true,
        documentacion: false
    });

    // Estado para controlar si el sidebar está expandido en móvil
    const [isMobileExpanded, setIsMobileExpanded] = useState(false);

    const handleCloseMobile = () => { if (onClose) onClose(); };

    const handleLogout = () => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('roleId');
        navigate('/login');
    };

    const toggleSection = (section) => {
        setOpenSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const toggleMobileSidebar = () => {
        setIsMobileExpanded(prev => !prev);
    };

    const isActive = (path) => location.pathname === path;

    const menuItems = [
        {
            id: 'objetos',
            title: 'Objetos',
            icon: 'bi-box-seam',
            roles: [1, 2, 3, 4],
            items: [
                { name: 'Inventario', url: '/inventory', icon: 'bi-list-ul' }
            ]
        },
        {
            id: 'supplies',
            title: 'Consumibles',
            icon: 'bi-box-seam',
            roles: [1, 2, 4],
            items: [
                { name: 'Consumibles', url: '/supplies', icon: 'bi-list-ul' },
                { name: 'Reporte Consumibles', url: '/suppliesreports', icon: 'bi-file-earmark-text' },
            ]
        },
        {
            id: 'reportes',
            title: 'Reportes',
            icon: 'bi-graph-up',
            roles: [1, 2, 3, 4],
            items: [
                { name: 'Ver Reportes', url: '/reports', icon: 'bi-file-earmark-text' },
                { name: 'Folios', url: '/folios', icon: 'bi-card-checklist' },
            ]
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            icon: 'bi-people',
            roles: [1],
            items: [
                { name: 'Lista de Usuarios', url: '/users', icon: 'bi-person-lines-fill' },
            ]
        },
        {
            id: 'configuraciones',
            title: 'Configuraciones',
            icon: 'bi-gear',
            roles: [1, 2, 3, 4],
            items: [
                { name: 'Ubicaciones', url: '/locations', icon: 'bi-geo-alt' },
                { name: 'Categorías', url: '/itemCategories', icon: 'bi-tag' },
                { name: 'Estados', url: '/itemStatus', icon: 'bi-dot' },
                { name: 'Unidades de medida', url: '/itemUnits', icon: 'bi-rulers' }
            ]
        },
        {
            id: 'excel-import',
            title: 'Importaciones',
            icon: 'bi-file-earmark-excel',
            roles: [1],
            items: [
                { name: 'Importación de Excel', url: '/excel-reports', icon: 'bi-file-earmark-excel' },
            ]
        },
        {
            id: 'conciliacion',
            title: 'Conciliación',
            icon: 'bi-file-earmark-excel',
            roles: [1, 2, 4],
            items: [
                { name: 'Conciliación de Inventario', url: '/inventory-reconciliation', icon: 'bi-diagram-3' },
            ]
        },
        {
            id: 'documentacion',
            title: 'Documentación',
            icon: 'bi-journal-text',
            roles: [1, 2, 3, 4],
            items: [
                {
                    name: 'Manual de usuario',
                    url: '/docs',
                    icon: 'bi-file-earmark-text'
                }
            ]
        }
    ];

    const filteredMenu = menuItems.filter(section => section.roles.includes(roleId));

    return (
        <>
            {isOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={handleCloseMobile}
                ></div>
            )}

            <div className={`sidebar ${isOpen ? 'mobile-expanded' : ''}`}>
                <div className="sidebar-user">
                    <div className="user-info">
                        <i className="bi bi-person-circle"></i>
                        <span className="user-name">{userName}</span>
                    </div>
                </div>

                {/* Enlace a Inicio */}
                <div className="sidebar-home">
                    <Nav.Link
                        onClick={() => {
                            navigate('/');
                            setIsMobileExpanded(false);
                        }}
                        className={`sidebar-home-link ${isActive('/') ? 'active' : ''}`}
                    >
                        <i className="bi bi-house-door"></i>
                        <span>Inicio</span>
                    </Nav.Link>
                </div>

                <Nav className="flex-column sidebar-nav">
                    {filteredMenu.map((section) => (
                        <div key={section.id} className="sidebar-section">
                            <div
                                className="sidebar-section-header"
                                onClick={() => toggleSection(section.id)}
                            >
                                <div className="section-title">
                                    <i className={`bi ${section.icon}`}></i>
                                    <span>{section.title}</span>
                                </div>
                                <i className={`bi ${openSections[section.id] ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                            </div>

                            <Collapse in={openSections[section.id]}>
                                <div>
                                    {section.items.map((item) => (
                                        <Nav.Link
                                            key={item.url}
                                            onClick={() => {
                                                navigate(item.url);
                                                handleCloseMobile();
                                            }}
                                            className={`sidebar-item ${isActive(item.url) ? 'active' : ''}`}
                                        >
                                            <i className={`bi ${item.icon}`}></i>
                                            <span>{item.name}</span>
                                        </Nav.Link>
                                    ))}
                                </div>
                            </Collapse>
                        </div>
                    ))}
                </Nav>

                <div className="sidebar-footer">
                    <Button
                        variant="outline-light"
                        size="sm"
                        className="logout-btn w-100"
                        onClick={handleLogout}
                    >
                        <i className="bi bi-box-arrow-right"></i>
                        <span>Cerrar sesión</span>
                    </Button>
                </div>
            </div>
        </>
    );
}

export default Sidebar;